import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { FiMapPin, FiCalendar, FiDollarSign, FiArrowRight } from 'react-icons/fi';
import { formatarData } from '../../utils/dateUtils';
import { getImageUrl } from '../../utils/imageUtils';

// Corrigir ícones padrão do Leaflet no React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

const CENTRO_BRASIL = [-14.235, -51.925];
const ZOOM_INICIAL = 4;

const MapaDestinos = () => {
  const [pontos, setPontos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMapa = async () => {
      try {
        const response = await axios.get('/api/viagens/mapa');
        setPontos(response.data);
      } catch (err) {
        console.error('Erro ao carregar mapa:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMapa();
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600" />
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold text-gray-900">Mapa de Destinos</h1>
        <p className="text-gray-600 mt-2">
          Clique nos marcadores para ver as viagens disponíveis em cada destino.
        </p>
      </div>

      <div className="rounded-xl overflow-hidden shadow-xl border border-gray-200 bg-white">
        <div className="h-[500px] w-full">
          <MapContainer
            center={CENTRO_BRASIL}
            zoom={ZOOM_INICIAL}
            style={{ height: '100%', width: '100%' }}
            scrollWheelZoom
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {pontos.map((p) => (
              <Marker key={p.id} position={[p.latitude, p.longitude]}>
                <Popup>
                  <div className="min-w-[220px]">
                    {p.imagem && (
                      <img
                        src={getImageUrl(p.imagem)}
                        alt={p.titulo}
                        className="w-full h-28 object-cover rounded mb-2"
                      />
                    )}
                    <h3 className="font-semibold text-gray-900">{p.titulo}</h3>
                    <p className="text-sm text-gray-600">{p.destino}</p>
                    <div className="flex items-center gap-2 text-sm text-gray-700 mt-1">
                      <FiCalendar size={14} />
                      {formatarData(p.data_ida)}
                      {p.data_volta && ` - ${formatarData(p.data_volta)}`}
                    </div>
                    <div className="flex items-center gap-2 text-sm font-medium text-sky-600 mt-1">
                      <FiDollarSign size={14} />
                      R$ {parseFloat(p.valor).toFixed(2)}
                    </div>
                    {p.local_embarque && (
                      <p className="text-sm text-gray-700 mt-2">
                        <span className="font-medium text-gray-600">Local de embarque: </span>
                        {p.local_embarque}
                      </p>
                    )}
                    <Link
                      to={`/viagem/${p.id}`}
                      className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-sky-600 hover:text-sky-700"
                    >
                      Ver detalhes
                      <FiArrowRight size={14} />
                    </Link>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>

      {pontos.length === 0 && (
        <div className="text-center py-12 bg-sky-50 rounded-xl border border-sky-100">
          <FiMapPin className="mx-auto text-sky-400 mb-4" size={48} />
          <p className="text-gray-600">
            Nenhum destino com localização no mapa no momento.
          </p>
          <p className="text-sm text-gray-500 mt-1">
            As viagens com latitude e longitude cadastradas aparecerão aqui.
          </p>
          <Link
            to="/viagens"
            className="inline-block mt-4 px-6 py-2 bg-sky-600 text-white rounded-lg hover:bg-sky-700"
          >
            Ver todas as viagens
          </Link>
        </div>
      )}

      {pontos.length > 0 && (
        <div className="mt-6 text-center">
          <Link
            to="/viagens"
            className="text-sky-600 hover:text-sky-700 font-medium inline-flex items-center gap-2"
          >
            Ver lista completa de viagens
            <FiArrowRight size={18} />
          </Link>
        </div>
      )}
    </div>
  );
};

export default MapaDestinos;
